import { useContextState } from "../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        drawer: {
            position: 'fixed',
            top: 0,
            right: 0,
            zIndex: 1000,
            background: `${colors.color5}11`,
            height: '100vh',
            width: '100vw'
        },
        children: {
            width: 'fit-content',
            height: '100%',
            float: 'right',
            background: colors.color5,
            boxShadow: '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)'
        }
    }
}

export { useStyles }